import { useMultiLngHandler } from '@healthhub/react-ui';
import { Layout } from 'antd';
import type { PropsWithChildren } from 'react';

import { i18n } from 'i18n';

import { useExtendedRouter } from '@shared/hooks/useExtendedRouter';

import { CommonFooter } from './CommonFooter';

const { Content } = Layout;

interface CommonLayoutProps {
  isHideFooter?: boolean;
}

const CommonLayout = ({ children, isHideFooter = false }: PropsWithChildren<CommonLayoutProps>) => {
  const { availableLanguages } = useExtendedRouter();

  useMultiLngHandler(i18n, availableLanguages);

  return (
    <Layout className="common-layout-container">
      <Layout className="common-layout">
        <Layout className="sider-content-container min-h-screen">
          <Layout>
            <Content className="content-container">
              <Content className="m-0 min-h-[280px]">{children}</Content>
            </Content>
          </Layout>
          {!isHideFooter && <CommonFooter />}
        </Layout>
      </Layout>
    </Layout>
  );
};

export default CommonLayout;
